import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function ApplySuccess() {
  return (
    <>
      <Header />
      <main
        className="container section"
        style={{ minHeight: "60vh", maxWidth: 640, textAlign: "center" }}
      >
        <div className="eyebrow">Application received</div>
        <h1
          className="display display--lg"
          style={{ marginTop: "1rem", marginBottom: "1rem" }}
        >
          we got it.
        </h1>
        <p className="lead" style={{ marginInline: "auto" }}>
          Check your inbox for a quick acknowledgement. We read every
          application personally, so it may take a few days to hear back. Either
          way, we'll email you with next steps.
        </p>
        <p style={{ marginTop: "2rem" }}>
          <Link to="/" className="btn btn--ghost">
            Back to the landing page
          </Link>
        </p>
      </main>
      <Footer />
    </>
  );
}
